<template>
  <path
    d="M20 3a1 1 0 0 1 .117 1.993L20 5H8a1 1 0 0 1-.117-1.993L8 3h12zm0 5a1 1 0 0 1 .117 1.993L20 10H8a1 1 0 0 1-.117-1.993L8 8h12zm0 5a1 1 0 0 1 .117 1.993L20 15H8a1 1 0 0 1-.117-1.993L8 13h12zm0 5a1 1 0 0 1 .117 1.993L20 20H8a1 1 0 0 1-.117-1.993L8 18h12zM4 3a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm0 5a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm0 5a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm0 5a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"
    fill="#010A0D"
    fill-rule="nonzero"
  />
</template>
